<template>
    <div class="page bg-gray page-flex pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="floor-list" v-if="curZone">
            <div class="floor-item" v-for="(layer,layerIndex) in curZone.wayItemInfoVOList" :key="layerIndex">
                <div class="title">{{layer.layerInfo}}</div>
                <div class="floor-product-list">
                    <div class="flex flex-center item" v-for="(product,productIndex) in layer.wayItemVOList" :key="productIndex">
                        <div class="item-img">
                            <img :src="product.mainPicView" alt="">
                        </div>
                        <div class="flex1 fs-28 ml-10 item-info">
                            <div class="color-main">货道{{product.wayCode}}</div>
                            <div class="color-333 text-el">{{product.productName}}</div>
                            <div class="mt-8 color-666">
                                数量：{{product.isWeightCalc == 1? (product.stockNum / 1000)+ 'kg': product.stockNum || 0 +'件'}}
                            </div>
                        </div>
                        <div class="peel-btn" @click="clearWeight(product)">去皮</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="clearWeight()">全部去皮</div>
        </div>
    </div>
</template>

<script>
    import { queryShopZoneWayItemList,clearWeight} from "@/api/shop"
    import {getToken,getAgentId} from '@/utils/util'
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "peel",
        components:{backTitleBar},
        data(){
            return {
                shopId:'',
                curZone:{},

            }
        },
        created(){
            if (this.$route.query.shopId) {
                this.shopId = this.$route.query.shopId;
            }
            this.getZoneItemList();
        },
        methods:{
            getZoneItemList() {
                let params = {
                    shopId: this.shopId
                }
                queryShopZoneWayItemList(params).then(res => {
                    this.curZone = res.data[0];
                })
            },

            clearWeight(data) {
                console.log(data);
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: '去皮前请确认货道里无商品，确定要去皮吗',
                    showCancelButton: true
                }).then(() => {     //点击确认按钮后的调用
                    let params = {
                        accessToken:getToken(),
                        agentId: getAgentId(),
                        shopId: _this.shopId,
                    }
                    if (data) {
                        params.zoneWayId = _this.curZone.descp + '-' + data.wayCode + '-'+ data.shopCode
                    } else {
                        params.zoneWayId = '0-000-0';
                    }
                    clearWeight(params).then(respon=>{
                        _this.$toast("操作成功");
                    })
                }).catch(() => { //点击取消按钮后的调用

                })

            }
        }
    }
</script>

<style scoped lang="scss">
    .floor-list{
        background: #F5F5F5;
        flex: 1;
        overflow-y: scroll;
        padding: .24rem;
    }
    .floor-item{
        background: #fff;
        border-radius: .12rem;
        margin-bottom: .12rem;
        .title{
            width: 1.2rem;
            height: .5rem;
            text-align: center;
            line-height: .5rem;
            background: $main-color;
            color: #fff;
            font-size: .28rem;
            border-radius: 0 .12rem .12rem 0;
        }
        .floor-product-list{
            padding: .24rem;
            .item{
                margin-bottom: .24rem;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
    .item-img{
        width: 1.24rem;
        height: 1.24rem;
    }
    .peel-btn{
        padding: 0 .4rem;
        border-radius: .1rem;
        height: .7rem;
        line-height: .7rem;
        color: #fff;
        background: $main-color;
        font-size: .3rem;
    }
    .page-flex{
        padding-bottom: 1.1rem;
    }
</style>



// WEBPACK FOOTER //
// peel.vue?bcf94c92